import { MessageSendState } from "../../types/enums";
import {Response, ComponentInterface, ResponseObject} from "../../types/chat";
import {MessageHistory} from "../chat/messageHistory";

export default class JsonComponent implements ComponentInterface {
    constructor(private readonly callback: (answer: Response) => void) {
    }

    resetSystemError(errorType: string): void {

    }

    showBotSuggestions(): void {
    }
    showBotGreeting(): void {
    }

    public closeChat( isError: boolean|null = null ): void
    {
    }

    public minimizeChat( ): void
    {
    }

    changeMessageStatus(id: string, status: MessageSendState): void {

    }

    public setAnswerContent(chatType: string, responseData: ResponseObject): void
    {
        let answerHtml = responseData.answerHtml;
        if(responseData.isError && responseData.useDefaultHtml) {
            answerHtml = "Es konnte keine passende Antwort gefunden werden. Bitte versuchen Sie es erneut.";
        }

        let response = {
            success: !responseData.isError,
            messageText: answerHtml,
            id: responseData.responseId
        };

        this.callback(response);
    }

    public setHistoryContent(chatType: string, messageHistory:MessageHistory): void
    {

    }

    public handleInvalidChatSessionError( errorType: string ): void
    {

    }

    setAgentIsTyping(duration: number): void {
    }

    public closeChatByAgent(): void {
    }

    closeWidget(): void {
    }
}